import { EventEmitter } from 'events';
import dispatcher from '../dispatcher/dispatcher';
import { buildRelationship } from '../action/pathAction';
import uuidv1 from 'uuid/v1';
import pathStore from './pathStore';
import { treeDelete } from '../services/relationshipBuilder';
import { deleteRelationship } from '../action/pathAction';
import { colourSet, colourPicker } from '../services/colour';
import { createImage } from '../action/imageAction';
import { shortnameGenerator, shortNameClashCheck, shortNameClashGlobalCheck } from "../services/utils";

/**
 * The tree store which holds all the nodes 
 * uses the tree object to hold all the nodes
 */
class TreeStore extends EventEmitter {
    constructor() {
        super();
        this.treeName = "";
        this.tree = {};
        this.deletedTree = [];
    }
    //@TODO add to a back-end api so that it can pull from a db
    async getTree() {
        // if(this.tree === {} )
        this.emit('Tree-Changes');
    }
    /**
     * Adds the node object into the tree object creates a shortname too
     * @param {*} treeObj object of the node to be added
     */
    addTree(treeObj) {
        let id = uuidv1();
        let shortNameFix;
        if (!treeObj.shortName) {
            let shortName = shortnameGenerator(treeObj.name);
            if (treeObj.type !== "docLib") {
                shortNameFix = shortNameClashGlobalCheck(shortName, id);
            } else {
                shortNameFix = shortNameClashCheck(shortName, treeObj.parent);

            }
            // if(shortNameFix === false){
            //     shortNameFix = shortnameGenerator(treeObj.name)
            // }
        } else {
            shortNameFix = treeObj.shortName;
        }
        let entry = {
            id: id,
            name: `${treeObj.name}`,
            shortName: shortNameFix,
            type: treeObj.type,
            sources: treeObj.sources,
            notes: treeObj.notes,
            flatten: treeObj.flatten,
            looseFiles: treeObj.looseFiles,
            parent: `${treeObj.parent}`,
            templateId: treeObj.templateId || 0
        };
        if (treeObj.colour) {
            entry.colour = colourPicker(treeObj.colour);
        } else {
            if (entry.parent === "0" && entry.type === "hub") {
                entry.colour = colourSet();
            } else if (entry.parent === "0") {
                entry.colour = colourPicker({ color: "yellow", alpha: 50 });
            }
        }

        this.tree[id] = entry;
        this.getTree();
        setTimeout(function () {
            buildRelationship(entry);
            if (treeObj.image) {
                createImage({ id: id, file: treeObj.image });

            }
        }, 0);
    }
    /**
     * used to edit a node within the tree Object
     * @param {*} treeObj 
     */
    editTree(treeObj) {
        let shortNameFix;
        if (!treeObj.shortName) {
            let shortName = shortnameGenerator(treeObj.name);
            shortNameFix = shortNameClashCheck(shortName, treeObj.parent);

        } else {
            shortNameFix = treeObj.shortName;
        }
        this.tree[treeObj.id].name = treeObj.name;
        this.tree[treeObj.id].type = treeObj.type;
        this.tree[treeObj.id].shortName = shortNameFix;
        this.tree[treeObj.id].sources = treeObj.sources;
        this.tree[treeObj.id].notes = treeObj.notes;
        this.tree[treeObj.id].flatten = treeObj.flatten;
        this.tree[treeObj.id].looseFiles = treeObj.looseFiles;
        this.tree[treeObj.id].templateId = treeObj.templateId;
        this.tree[treeObj.id].theme = treeObj.theme;

        if (treeObj.colour) {
            this.tree[treeObj.id].colour = colourPicker(treeObj.colour);
        }
        if (treeObj.image) {
            setTimeout(function () {
                createImage({ id: treeObj.id, file: treeObj.image });
            }, 0);
        }
        this.emit('Tree-Changes');
    }
    //removes the deleted from the array but also adds them to a seperate array
    deleteTreeEntity(treeObj) {
        let relationships = pathStore.relationship;
        treeDelete(treeObj, relationships).then((deleteArray => {
            if (deleteArray.length === 0) {
                if (this.tree[treeObj]) {
                    delete this.tree[treeObj];
                    this.deletedTree.push(treeObj);

                }
            }
            deleteArray.forEach((element => {
                if (this.tree[element.id]) {
                    delete this.tree[element.id];
                    this.deletedTree.push(element.id);
                }
            }));
            this.getTree();

            setTimeout(function () {
                deleteRelationship(deleteArray);
            });
        }));
    }
    /**
     * Used for setting the tree object from the api
     * @param {*} obj 
     */
    setTree(obj) {
        if (obj.nodes) {
            this.tree = obj.nodes;
            Object.keys(this.tree).forEach((tree) => {
                if (this.tree[tree].parent === "0" && this.tree[tree].type === "hub") {
                    this.tree[tree].colour = colourSet();
                }
            });

        } else {
            this.tree = {};
        }
        if (obj.deleteTree) {
            this.deletedTree = obj.deleteTree;
        } else {
            this.deletedTree = [];
        }
        if (obj.treeName) {
            this.treeName = obj.treeName;
        } else {
            this.treeName = "";
        }
        // this.emit('Tree-Changes');
        this.emit("Set-Tree");
        this.getTree();
    }
    /**
     * @todo maybe delete this
     * @param {*} treeName 
     */
    setTreeName(treeName) {
        if (treeName === null) {
            return;
        }
        this.treeName = treeName;
        this.emit('Name-Changes');
    }
    actionHandler(action) {
        switch (action.type) {
            case 'GET_TREE': {
                this.getTree();
                break;
            }
            case 'ADD_TREE': {
                this.addTree(action.object);
                break;
            }
            case 'EDIT_TREE': {
                this.editTree(action.object);
                break;
            }
            case 'DELETE_TREE': {
                this.deleteTreeEntity(action.object);
                break;
            }
            case 'SET_TREE': {
                this.setTree(action.object);
                break;
            }
            case 'SET_TREE_NAME': {
                this.setTreeName(action.object);
                break;
            }
            default: {
                break;
            }
        }
    }
}

const treeStore = new TreeStore();
dispatcher.register(treeStore.actionHandler.bind(treeStore));

export default treeStore;


// WEBPACK FOOTER //
// ./src/store/treeStore.js